import {
	createTownsquareCypherQuery,
	createJiraIssueCypherQuery,
	createPullRequestCypherQuery,
} from '@atlassian/home-assigned/assigned-list/cypher-query-builders';
import { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line no-restricted-imports -- Retained until the Townsquare router facade migration is completed; see VOLTPLAT-330.
import { RouteResource } from 'react-resource-router';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import AssignedQuery, { AssignedQuery as AssignedQueryType } from '../components/__generated__/AssignedQuery.graphql';

const QUERY_CONTEXT_PREFIX_SITE = 'ari:cloud:platform::site/';
const DEFAULT_LIMIT = 25;

export const assignedResource: RouteResource<PreloadedQuery<AssignedQueryType, Record<string, unknown>>> =
	createRelayResource<AssignedQueryType>({
		getQuery: (_routerContext, resourceContext) => {
			const isEnabled = fg('townsquare_enable_global_assigned');

			const context = resourceContext as HomeResourceContext;
			const accountId = context.user.accountId;
			const cloudId = context?.collabContext?.rovoWorkspace;

			const queryContext = `${QUERY_CONTEXT_PREFIX_SITE}${context?.collabContext?.rovoWorkspace}`;

			return {
				environment: getAggRelayEnvironment(),
				query: AssignedQuery,
				variables: {
					townsquareQuery: createTownsquareCypherQuery(accountId),
					jiraIssueQuery: createJiraIssueCypherQuery(accountId),
					pullRequestQuery: createPullRequestCypherQuery(accountId),
					queryContext,
					first: DEFAULT_LIMIT,
					isEnabled: isEnabled && !!cloudId,
				},
				options: {
					fetchPolicy: 'store-and-network',
				},
			};
		},
	});
